import React, { useState } from 'react';

import MainContent from 'components/MainContent';
import VehicleFilters from 'modules/vehicle-section/VehicleList/Filters';
import VehicleList from 'modules/vehicle-section/VehicleList/List';
import CarrierCallStatusModal from '../CarrierCallStatus/CarrierCallStatusModal';

const VehicleListWithFilters = (props) => {
  const [carrierIdCallStatus, setCarrierIdCallStatus] = useState(null);
  return (
    <MainContent>
      <div>
        <VehicleFilters />
        <VehicleList showModal={(id) => setCarrierIdCallStatus(id)} />
        {carrierIdCallStatus && (
          <CarrierCallStatusModal
            carrierId={carrierIdCallStatus}
            onClose={() => setCarrierIdCallStatus(null)}
          />
        )}
      </div>
    </MainContent>
  );
};

export default VehicleListWithFilters;
